(function () {
  function enhanceTermsContent(root) {
    if (!root || root.dataset.termsContentEnhanced === 'true') return;
    root.dataset.termsContentEnhanced = 'true';

    root.querySelectorAll('h2').forEach((el) => el.classList.add('c-heading-lvl2'));
    root.querySelectorAll('h3').forEach((el) => el.classList.add('c-heading-lvl3'));
    root.querySelectorAll('h4').forEach((el) => el.classList.add('c-heading-lvl4'));
    root.querySelectorAll('h5').forEach((el) => el.classList.add('c-heading-lvl5'));

    root.querySelectorAll('p').forEach((p) => {
      const prev = p.previousElementSibling;
      if (prev && prev.matches('h2') && p.querySelector('strong')) {
        p.classList.add('c-text-lead');
      } else {
        p.classList.add('c-text-body');
      }
    });

    root.querySelectorAll('ul').forEach((list) => {
      list.classList.add('c-list', 'c-list--unordered');
    });
    root.querySelectorAll('ol').forEach((list) => {
      list.classList.add('c-list', 'c-list--ordered');
    });
    root.querySelectorAll('ul > li, ol > li').forEach((item) => item.classList.add('c-list-ordered__item'));
  }

  function init() {
    document.querySelectorAll('.c-terms-page-content').forEach(enhanceTermsContent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
